module.exports = __webpack_public_path__ + "static/img/10.e43f5e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/10.png
// module id = re2t
// module chunks = 0